import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const BarChartSimple = ({ data, loading }) => {
    if (loading) return <div>Loading...</div>;
    if (!data || data.length === 0) return <div>No data available</div>;

    const maxVal = Math.max(...data.map(d => parseFloat(d.total || 0)));

    return (
        <div style={{ padding: '8px 0' }}>
            {data.map((item, idx) => (
                <div key={idx} className="bar-chart-row">
                    <Text className="bar-chart-label" title={item.label}>{item.label}</Text>
                    <div className="bar-chart-track">
                        <div
                            className="bar-chart-fill"
                            style={{ width: `${(parseFloat(item.total) / maxVal) * 100}%` }}
                        />
                    </div>
                    <Text className="bar-chart-value">{item.qty} units</Text>
                </div>
            ))}
        </div>
    );
};

export default BarChartSimple;
